const env_config: any = {
  "table-tronic": {
    primaryColor: "24.6 95% 53.1%",
    primaryDark: "142.4,71.8%,18%",
    domain: "one-suite.cloud",
    logo: "/tb_logo.svg",
    name: "TableTronic",
  },
  "one-suite": {
    primaryColor: "206 95% 37%",
    primaryDark: "206 94% 27",
    domain: "one-suite.cloud",
    logo: "/logo_iconn.png",
    name: "OneSuite",
  },
};

const app_env = import.meta.env.VITE_APP_ENVIRONMENT || "one-suite";

export { env_config, app_env };
